import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ViewTournamentItemsNew from './GroupEventItem/ViewTournamentItemsNew';
import { scrollToTop } from '../utils/UiHelper';

const ViewGroupItemsNew = (props) => {
    let groups1 = [];
    let groups2 = [];

    const sortByIds = props.danmarkItems
        ? props.danmarkItems.map((i) => i.item_id)
        : [];

    Object.keys(props.data.groups).map((key) => {
        const isDannmark = sortByIds.indexOf(props.data.groups[key].id + '');

        if (props.data.groups[key].priority > 0) {
            groups1.push(props.data.groups[key]);
        } else {
            if (isDannmark === -1) {
                groups2.push(props.data.groups[key]);
            } else {
                groups1.push(props.data.groups[key]);
            }
        }

        return key;
    });

    useEffect(() => {
        if (!window.location.pathname.split('/').includes('pre')) {
            !window.location.pathname.split('/').includes('pre') &&
                scrollToTop();
        }
    }, []);

    return (
        <div>
            {groups1
                .sort((a, b) => {
                    if (sortByIds.length > 0 && !a.priority && !b.priority) {
                        const t1 = sortByIds.indexOf(a.id + '');
                        const t2 = sortByIds.indexOf(b.id + '');

                        if (t1 > -1 && t2 > -1) {
                            return t1 - t2;
                        } else {
                            if (t1 < t2) {
                                return 1;
                            }

                            if (t1 > t2) {
                                return -1;
                            }
                        }
                    }

                    if (a.priority > b.priority) {
                        return 1;
                    }
                    if (a.priority < b.priority) {
                        return -1;
                    }

                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }

                    return 0;
                })
                .map((group, index) => {
                    return (
                        <ViewTournamentItemsNew
                            key={index}
                            sport={props.data.name}
                            group={group}
                            data={group.tournaments}
                            listType={props.listType}
                            limit={props.limit}
                            showFavorites={props.showFavorites}
                            isFirstGroupOpened={props.isFirstGroupOpened}
                            tournament={props.tournament}
                        />
                    );
                })}

            {groups2
                .sort((a, b) => {
                    if (sortByIds.length > 0) {
                        const t1 = sortByIds.indexOf(a.id + '');
                        const t2 = sortByIds.indexOf(b.id + '');

                        if (t1 > -1 && t2 > -1) {
                            return t1 - t2;
                        } else {
                            if (t1 < t2) {
                                return 1;
                            }

                            if (t1 > t2) {
                                return -1;
                            }
                        }
                    }

                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }

                    return 0;
                })
                .map((group) => (
                    <ViewTournamentItemsNew
                        key={group.id}
                        sport={props.data.name}
                        group={group}
                        data={group.tournaments}
                        listType={props.listType}
                        limit={props.limit}
                        showFavorites={props.showFavorites}
                        isFirstGroupOpened={props.isFirstGroupOpened}
                        tournament={props.tournament}
                    />
                ))}
        </div>
    );
};

const mapStateToProps = (state) => {
    return { danmarkItems: state.ui.danmarkItems };
};

export default connect(
    mapStateToProps,
    null
)(ViewGroupItemsNew);
